import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import { useForm } from "react-hook-form";
import { CpfInputs } from "./CpfInputs";
import { RadioButton } from "primereact/radiobutton";
import { CnpjInputs } from "./CnpjInputs";
import { Spouse } from "../Spouse";

export const PersonalData = forwardRef(
  (
    {
      file,
      spouse,
      setFile,
      baseData,
      contacts,
      setSpouse,
      telephones,
      editClient,
      setAddress,
      setContacts,
      typeRegister,
      personalData,
      setTelephones,
      setTypeRegister,
      cumulativeTooltip,
      setCumulativeTooltip,
      onSubmitPersonal,
    },
    ref
  ) => {
    const {
      control,
      setValue,
      getValues,
      handleSubmit,
      formState: { errors },
    } = useForm();
    const [inputRequireds, setInputRequireds] = useState([]);
    const [spouseVisible, setSpouseVisible] = useState(false);
    const [editPartner, setEditPartner] = useState(null);
    const cpfInputsRef = useRef(null);

    const handleInputRequireds = () => {
      var auxRegisterGeneral = localStorage.getItem("registerGeneral");
      setInputRequireds(auxRegisterGeneral);
    };

    useImperativeHandle(ref, () => ({
      submit: () => {
        return handleSubmit(onSubmitPersonal)();
      },
      getValues: () => getValues(),
    }));

    useEffect(() => {
      handleInputRequireds();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (personalData) {
        // Se os dados de edição incluem type_doc, define o typeRegister adequadamente PRIMEIRO
        if (personalData.type_doc && editClient) {
          console.log("PersonalData - type_doc recebido:", personalData.type_doc);
          if (personalData.type_doc === 1 || personalData.type_doc === "1") {
            console.log("PersonalData - Definindo typeRegister como 'fisica'");
            setTypeRegister("fisica");
          } else if (personalData.type_doc === 2 || personalData.type_doc === "2") {
            console.log("PersonalData - Definindo typeRegister como 'juridica'");
            setTypeRegister("juridica");
          }
        }
        
        Object.keys(personalData).forEach((key) => {
          if (key === "date_issuing_authority" || key === "date_of_birth") {
            setValue(key, new Date(personalData[key]));
          } else {
            setValue(key, personalData[key]);
          }
        });
      }
    }, [personalData, setValue, editClient, setTypeRegister]);

    useEffect(() => {
      if (baseData) {
        // console.log("bd", baseData);
        if (baseData.name) {
          setValue("name", baseData.name);
        }
        if (baseData.phone) {
          setValue("contacts[0]", baseData.phone);
          setValue("type_numbers[0]", 1);
        }
      }
    }, [baseData]);

    // Define o type_doc baseado no typeRegister
    useEffect(() => {
      if (typeRegister === "fisica") {
        setValue("type_doc", "1");
      } else if (typeRegister === "juridica") {
        setValue("type_doc", "2");
      }
    }, [typeRegister, setValue]);

    return (
      <>
        <form onSubmit={handleSubmit(onSubmitPersonal)}>
          <div className="row py-3 d-flex justify-content-between w-100">
            <div className="col-md-4">
              <div className="inline-flex align-items-center">
                <i className="pi pi-user me-2"></i>
                <b>Informações Básicas</b>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-end px-0">
              {editClient ? (
                <>
                  {typeRegister === "fisica" ? (
                    <div className="col-md-6 px-0">
                      <span
                        className={`${
                          typeRegister === "fisica"
                            ? "btn-radio-register "
                            : "btn-radio-register-inactive "
                        } text-wrap rounded-4 btn-sm btn d-flex align-items-start p-2`}
                      >
                        <RadioButton
                          value="fisica"
                          inputId="fisica"
                          name="typeregister"
                          checked={typeRegister === "fisica"}
                          onChange={(e) => {
                            setTypeRegister(e.value);
                            setValue("doc", "");
                          }}
                        />
                        <label
                          htmlFor="typeRegister1"
                          id="typeRegister1"
                          className="ms-2"
                          style={{ fontSize: "15px" }}
                        >
                          Física
                        </label>
                      </span>
                    </div>
                  ) : (
                    <div className="col-md-6 px-0">
                      <span
                        className={`${
                          typeRegister === "juridica"
                            ? "btn-radio-register"
                            : "btn-radio-register-inactive"
                        } text-wrap rounded-4 btn-sm btn d-flex p-2`}
                      >
                        <RadioButton
                          value="juridica"
                          inputId="juridica"
                          name="typeregister"
                          checked={typeRegister === "juridica"}
                          onChange={(e) => {
                            setTypeRegister(e.value);
                            setValue("doc", "");
                          }}
                        />
                        <label
                          htmlFor="typeRegister2"
                          id="typeRegister2"
                          className="ms-2"
                          style={{ fontSize: "15px" }}
                        >
                          Jurídica
                        </label>
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="col-md-6 px-0">
                    <span
                      className={`${
                        typeRegister === "fisica"
                          ? "btn-radio-register "
                          : "btn-radio-register-inactive "
                      } text-wrap rounded-4 btn-sm btn d-flex align-items-start p-2`}
                    >
                      <RadioButton
                        value="fisica"
                        inputId="fisica"
                        name="typeregister"
                        checked={typeRegister === "fisica"}
                        onChange={(e) => {
                          setTypeRegister(e.value);
                          setValue("doc", "");
                        }}
                      />
                      <label
                        htmlFor="typeRegister1"
                        id="typeRegister1"
                        className="ms-2"
                        style={{ fontSize: "15px" }}
                      >
                        Física
                      </label>
                    </span>
                  </div>
                  <div className="col-md-6 px-0">
                    <span
                      className={`${
                        typeRegister === "juridica"
                          ? "btn-radio-register"
                          : "btn-radio-register-inactive"
                      } text-wrap rounded-4 btn-sm btn d-flex p-2`}
                    >
                      <RadioButton
                        value="juridica"
                        inputId="juridica"
                        name="typeregister"
                        checked={typeRegister === "juridica"}
                        onChange={(e) => {
                          setTypeRegister(e.value);
                          setValue("doc", "");
                        }}
                      />
                      <label
                        htmlFor="typeRegister2"
                        id="typeRegister2"
                        className="ms-2"
                        style={{ fontSize: "15px" }}
                      >
                        Jurídica
                      </label>
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>

          {(() => {
            return typeRegister === "fisica" ? (
              <CpfInputs
                file={file}
                ref={cpfInputsRef}
                spouse={spouse}
                errors={errors}
                control={control}
                setFile={setFile}
                setValue={setValue}
                contacts={contacts}
                setSpouse={setSpouse}
                getValues={getValues}
                telephones={telephones}
                setContacts={setContacts}
                setTelephones={setTelephones}
                inputRequireds={inputRequireds}
                setSpouseVisible={setSpouseVisible}
                setEditPartner={setEditPartner}
              />
            ) : (
              <CnpjInputs
                file={file}
                errors={errors}
                setFile={setFile}
                control={control}
                setValue={setValue}
                contacts={contacts}
                getValues={getValues}
                setAddress={setAddress}
                telephones={telephones}
                setTelephones={setTelephones}
                inputRequireds={inputRequireds}
                cumulativeTooltip={cumulativeTooltip}
                setCumulativeTooltip={setCumulativeTooltip}
              />
            );
          })()}
        </form>
        <Spouse
          errors={errors}
          control={control}
          setValue={setValue}
          getValues={getValues}
          onChangeSpouse={(data) => {
            setValue("spouse_id", data.id);
            setSpouse(data);
          }}
          onClose={() => setSpouseVisible(false)}
          visible={spouseVisible}
          setSpouse={setSpouse}
          inputRequireds={inputRequireds}
          editPartner={editPartner}
        />
      </>
    );
  }
);
